module.exports = __webpack_public_path__ + "static/img/2_2_2.dc30a7ab.jpg";